import { Text } from '@doordash/design-language'
import styled from 'styled-components'

export const ReferralLink = styled(Text)`
  text-decoration: underline;
  cursor: pointer;
`
